import React from 'react';

const NotFond = () => {
    return (
        <div className='flex justify-center items-center flex-col-reverse h-[84vh] bg-[#ffeae7]'>

            <p className='text-2xl'>Woops, Look like this page doesn't exist</p>
            <h1 className='text-7xl font-bold text-[#ff634e] mb-8'>Error 404</h1>
        </div>
    );
};

export default NotFond;